<template>
    <div class="result-info">
        <!-- 考试得分 -->
        <div class="cartogram-total">
            <div class="cartogram flex-sh" id="cartogram-a"></div>
            <div class="pro-c">
                <div class="pro-c1">
                    <span id="pulsz" class="font-s26 col-1">0</span>
                    <span class="font-s12 col-2">分</span>
                </div>
                <div class="pro-c2">{{pageData.sum_score >=60?'合格':'不及格'}}</div>
            </div>
        </div>
        <!-- 考生信息 -->
        <div class="re-per">
            <div class="flex-szb">
                <div class="re-name">{{pageData.real_name}}</div>
                <div class="re-tit flex-sh">答错:{{pageData.err_count}}题</div>
            </div>
            <div class="re-con">
                <div><span>单位名称：</span>{{pageData.company_name}}</div>
<!--                <div><span>上岗证号：</span>{{pageData.company_no}}</div>-->
            </div>
        </div>
        <!-- 错题&再试一次 -->
        <div class="fl-btn-a flex-szb">
            <a @click="$router.push({path:'/home/analysis?merUid=' + merUid + '&examId=' +examId + '&examResId=' + examResId+'&errCount='+pageData.err_count+'&errCurr=1'})">查看错题解析</a>
            <a class="col-j1 col-0" @click="$router.push({path:'/home/info?merUid=' + merUid + '&examId=' + examId })">再试一次</a>
        </div>
        <!-- 游客推广 -->
        <div class="yk-xuanchuan" v-if="merUid==0" >
            <img :src="pageData.ad_url" alt="">
            <div>
				 <p style="padding:20px 30px;text-align: left">{{pageData.ad_msg}}</p>
            </div>
        </div>

        <!-- 注册用户历史记录 -->
        <div class="score-his" v-if="merUid!=0">
            <div class="list-sty-v1 font-s15 font-b">历史成绩</div>
            <div class="score-con">
                <div class="his-list">
                    <div v-for="item in pageData.history">
                        <i></i>
                        <div class="his-date" v-if="item.submit_time>0">{{new Date(item.submit_time*1000).format("yyyy-MM-dd hh:mm:ss")}}</div>
                        <div class="his-date" v-else>超时未提交成绩</div>
                        <div><span class="fx-num">{{item.sum_score}}</span>分</div>
                    </div>

                </div>
            </div>
        </div>
        <!--广告-->
<!--        <div style="border: 1px solid #cbcbcb;margin-top: 20px;">-->
<!--            <img class="ad-h5" :src="getImgUrl('images/ui/da-1.jpg')" alt="">-->
<!--            <img :src="getImgUrl('images/ui/da-2.jpg')" alt="" class="ad-web">-->
<!--        </div>-->
    </div>
</template>

<script>
    export default {
        name: "Result",
        data: function () {
            return {
                examId: null,
                merUid: null,
                examResId: null,
                pageData: {},
            }
        },
        mounted: function () {
            document.title = "考试成绩";
            document.body.className = "col-b1 font-s13 flex-sh result-pic";
            window.setCss("/css/dati.css");


            this.examId = this.$route.query.examId;
            this.merUid = this.$route.query.merUid;
            this.examResId = this.$route.query.examResId;
            this.loadData();
        },
        methods: {
            getImgUrl(path) {
                return process.env.BASE_URL + path;
            },
            loadData() {
                this.$axios.get("/answers/result?merUid=" + this.merUid + "&examId=" + this.examId + "&examResId=" + this.examResId).then(res => {
                    this.pageData = res.data.data;
                    this.$nextTick(function () {
                        window.setRadialIndicator(this.pageData.sum_score);
                    })

                })
            }
        }
    }
</script>

<style scoped>

</style>
